export default "__VITE_ASSET__DjxwtNOC__"